import { render } from "./settings_service_provider_tab.html?vue&type=template&id=e2939b0a&external"
import script from "./settings_service_provider_tab.js?vue&type=script&lang=js&external"
export * from "./settings_service_provider_tab.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__